import { BigNumber, BigNumberish } from "ethers";
import network from "./network";

export interface LSDBagTokenType {
    name: string,
    address: string;
    multiplier: number;
    knottingFee: number;
    unknottingFee: number;
    minBagAmount: BigNumberish;
}

// We don't need to fetch this data as it won't change very often
export const LSDBagTokens: LSDBagTokenType[] = [
    {
        name: "TIKU",
        address: network.tikuContractAddress,
        multiplier: 40,
        knottingFee: 0,
        unknottingFee: 2,
        minBagAmount: BigNumber.from(10).pow(18).mul(500000)
    },
    {
        name: "Testing Token",
        address: "0x05FBb27f65081A27A1982301Cf3d463cf1fC9dB0" ,
        multiplier: 40,
        knottingFee: 5,
        unknottingFee: 10,
        minBagAmount: BigNumber.from(10).pow(18).mul(350000)
    }
]